var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer v2"},[_c('div',{staticClass:"copyright v2"},[_vm._v(_vm._s(_vm.copyright))])])
}
var staticRenderFns = []

export { render, staticRenderFns }